module.exports = __webpack_public_path__ + "img/participant-iwata.f8602d43.svg";